import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import axios from "axios";
import Sidebar from "./Sidemenu";
import { useNavigate, useLocation } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import "bootstrap/dist/css/bootstrap.min.css";

const Contact = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_emailid: "",
    user_phonenumber: "",
    user_country: "",
    user_age: "",
    user_gender: "male",
    points: "",
    user_id: "",
  });
  const [contactDetails, setContactDetails] = useState([" "]);
  const [isLoading, setIsLoading] = useState(false);

  const [showTempModal, setShowTempModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);

  const handleShowModal = () => setShowTempModal(true);
  const handleCloseModal = () => setShowTempModal(false);
  const handleSelectTemplate = (template) => setSelectedTemplate(template);
  const handleTempSubmit = async () => {
    if (selectedTemplate) {
      console.log(`Sending email using template: ${selectedTemplate.name}`);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/send-multiple-Email`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attachment: selectedTemplate.name,
            }),
          }
        );

        if (response.ok) {
          console.log("Email sent successfully!");
        } else {
          throw new Error(`Failed to send email. Status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error sending email:", error.message);
      }
      handleCloseModal();
    } else {
      alert("Please select a template.");
    }
  };

  const validateEmail = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/validateContact`
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Validation Results:", data); // Log or use the data
        fetchContactDetails();
      } else {
        throw new Error("Failed to fetch contact details");
      }
    } catch (err) {
      console.error("Error while validating emails:", err);
      throw err; // Optionally rethrow the error for further handling
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/allTemplatePreviews`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch templates: ${response.statusText}`);
      }

      const data = await response.json();
      if (data.success) {
        return data.templates; // Assumes templates have 'name' and 'preview' properties
      } else {
        throw new Error("Failed to load templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      return [];
    }
  };
  const fetchContactDetails = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/userDetails`
      );
      if (response.ok) {
        const data = await response.json();
        setContactDetails(data);
      } else {
        throw new Error("Failed to fetch contact details");
      }
    } catch (error) {
      console.error("Error fetching contact details:", error);
    }
  };

  // Fetch contact details on component mount
  useEffect(() => {
    fetchContactDetails();

    const loadTemplates = async () => {
      const fetchedTemplates = await fetchAllTemplates();
      setTemplates(fetchedTemplates);
    };
    loadTemplates();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/userDetails`,
        formData
      );
      setShowModal(false);
      fetchContactDetails(); // Fetch updated contact details after submission
      setFormData({
        user_name: "",
        user_emailid: "",
        user_phonenumber: "",
        user_country: "",
        user_age: "",
        user_gender: "male",
        points: "",
        user_id: "",
      });
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ClipLoader color="#36d7b7" size={50} />
      </div>
    );
  }

  return (
    <div className="container-fluid d-flex ">
      <Sidebar />
      <div
        className="flex-grow-1 p-4"
        style={{ width: "100%", height: "100vh", overflowY: "auto" }}
      >
        <div style={{ marginTop: "30px" }}>
          <h1>Contact Details</h1>
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <Button variant="primary" onClick={() => setShowModal(true)}>
              Quick Add
            </Button>
            <Button variant="primary" onClick={validateEmail}>
              Validate
            </Button>
            <Button variant="primary" onClick={handleShowModal}>
              Send Mail
            </Button>
          </div>

          <Modal
            show={showTempModal}
            onHide={handleCloseModal}
            style={{ width: "100%" }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select a Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px",
                  height: "50vh",
                  overflowY: "auto",
                }}
              >
                {templates.map((template) => (
                  <div
                    key={template.id}
                    onClick={() => handleSelectTemplate(template)}
                    style={{
                      width: "48%",
                      padding: "20px",
                      border: "1px solid gray",
                      cursor: "pointer",
                      backgroundColor:
                        selectedTemplate === template ? "#007bff" : "white",
                      color: selectedTemplate === template ? "white" : "black", // Ensure text contrast
                    }}
                  >
                    {template.name}
                  </div>
                ))}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleTempSubmit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Add User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="user_name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_emailid">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="user_emailid"
                    value={formData.user_emailid}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_phonenumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_phonenumber"
                    value={formData.user_phonenumber}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_country"
                    value={formData.user_country}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_age">
                  <Form.Label>Age</Form.Label>
                  <Form.Control
                    type="number"
                    name="user_age"
                    value={formData.user_age}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_gender">
                  <Form.Label>Gender</Form.Label>
                  <Form.Control
                    as="select"
                    name="user_gender"
                    value={formData.user_gender}
                    onChange={handleChange}
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="points">
                  <Form.Label>Points (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="points"
                    value={formData.points}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group controlId="user_id">
                  <Form.Label>ID (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_id"
                    value={formData.user_id}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Country</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Points</th>
                <th>ID</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {contactDetails.map((contact) => (
                <tr key={contact._id}>
                  <td>{contact.user_name}</td>
                  <td>{contact.user_emailid}</td>
                  <td>{contact.user_phonenumber}</td>
                  <td>{contact.user_country}</td>
                  <td>{contact.user_age}</td>
                  <td>{contact.user_gender}</td>
                  <td>{contact.points}</td>
                  <td>{contact.user_id}</td>
                  <td>{contact.emailStatus}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default Contact;
